import { FormControl } from '@angular/forms';
import { ApiRoute } from '@sb/library/api';
import { BodyRequired, FileSize, OneParameterRequired, SimpleDialogData, UploadFileType } from '@sb/library/base';
import { IncludesStream } from '@sb/library/data-models';

export class UploadData {
    constructor(initializer?: Partial<UploadData>) {
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    ID?: string;
    InputItem?: IncludesStream;
    File!: File;
}
export class UploadingDialogData {
    constructor(initializer?: Partial<UploadingDialogData>) {
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    Title?: string = "";
    Text?: string = "";
    IsDismissable?: boolean = true;
    PrimaryButtonText?: string | null = null;
    SecondaryButtonText?: string | null = null;

    DeleteOnCancel?: boolean;
    Files?: Array<UploadData> | null = null;
    ApiSubmitRoute!: ApiRoute<OneParameterRequired & BodyRequired<FormData>, string> |
                ApiRoute<BodyRequired<FormData>, string>;
    ApiDeleteRoute?: ApiRoute<OneParameterRequired, boolean>;
}

export class UploadDialogData extends SimpleDialogData {

    constructor(initializer?: Partial<UploadDialogData>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    AcceptedFormat: UploadFileType = UploadFileType.All;
    AllowMultiFileUpload: boolean = true;
    Control: FormControl<File[]> | null = null;
    MaxAllowedFilesize: FileSize = FileSize.Maximum.Attachment.Size2GB;
    HideInlineErrors: boolean = false;
    SnackbarAction?: () => void;
}

export class UploadLogoDialogData extends SimpleDialogData {
    constructor(initializer?: Partial<UploadDialogData>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    Control: FormControl<File[]> | null = null;
    MaxAllowedFilesize: FileSize = FileSize.Maximum.Attachment.Size2GB;
    SnackbarAction?: () => void;
}
